var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer-menu" },
    [
      _c("wrapper", { staticClass: "desktop" }, [
        _c("div", { staticClass: "row-menu" }, [
          _c("div", { staticClass: "column-logo" }, [
            _c(
              "div",
              { staticClass: "inner" },
              [
                _c("link-to", { staticClass: "logo", attrs: { to: "/" } }, [
                  _c("img", {
                    attrs: { src: "/logo.png", alt: "Russ Outdoor" }
                  })
                ])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "column-menu" }, [
            _c(
              "ul",
              { staticClass: "main-item" },
              _vm._l(_vm.menu, function(value, index) {
                return _c("li", { key: index, staticClass: "item" }, [
                  _c(
                    "a",
                    { staticClass: "main", attrs: { href: value.link } },
                    [_vm._v(_vm._s(value.name))]
                  ),
                  value.items
                    ? _c(
                        "ul",
                        _vm._l(value.items, function(v, i) {
                          return _c(
                            "li",
                            { key: i },
                            [
                              _c(
                                "nuxt-link",
                                { staticClass: "i", attrs: { to: v.link } },
                                [_vm._v(_vm._s(v.name))]
                              )
                            ],
                            1
                          )
                        })
                      )
                    : _vm._e()
                ])
              })
            ),
            _c(
              "div",
              [_c("social-links", { attrs: { buttonClass: "round--white" } })],
              1
            )
          ])
        ]),
        _vm.copyright
          ? _c("div", { staticClass: "row-copyright" }, [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.copyright) } })
            ])
          : _vm._e(),
        _c("div", { staticClass: "text-center" }, [
          _c(
            "a",
            {
              staticClass: "a-white solid oferta",
              staticStyle: { "margin-right": "10px" },
              attrs: {
                href: "/upload/docs/pdf/privacy_policy_www.pdf",
                target: "_blank"
              }
            },
            [_vm._v("Политика конфиденциальности")]
          ),
          _c(
            "a",
            {
              staticClass: "a-white solid oferta",
              staticStyle: { "margin-right": "10px" },
              attrs: { href: "/illegal_actions_message/", target: "_blank" }
            },
            [_vm._v("Сообщить о противоправных действиях")]
          ),
          _c("br"),
          _vm.isDocsPage
            ? _c(
                "a",
                {
                  staticClass: "a-white solid oferta",
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    href: "https://files.russoutdoor.ru/cp/",
                    target: "_blank"
                  }
                },
                [_vm._v("Коммерческая политика")]
              )
            : _vm._e()
        ])
      ]),
      _c("wrapper", { staticClass: "mobile" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _vm.copyright
              ? _c("div", {
                  staticClass: "copyright",
                  domProps: { innerHTML: _vm._s(_vm.copyright) }
                })
              : _vm._e(),
            _c("social-links", { attrs: { buttonClass: "round--white" } })
          ],
          1
        ),
        _c("div", { staticClass: "text-center oferta" }, [
          _c(
            "a",
            {
              staticClass: "a-white",
              attrs: { href: "/oferta", target: "_blank" }
            },
            [_vm._v("Политика конфиденциальности")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51508403", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51508403","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/footer/FooterMenu.vue
// module id = dEhO
// module chunks = 41